export class SignUpModel {
  cnpj!: string | null;
  password!: string | null;
  passIsValid!: boolean | undefined;
  recaptcha!: string | null;
}
